module.exports = __webpack_public_path__ + "img/svg/more-vertical.67ce622e0e97e2a1bbe7c62e09249a73.svg";